import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  sae_types: [],
  sae_type: null
}

// mutations
export const mutations = {
  [types.SET_SAE_TYPES](state, sae_types) {
    state.sae_types = sae_types
  },
  [types.SET_SAE_TYPE] (state, sae_type) {
    state.sae_type = sae_type
  },
  [types.FETCH_SAE_TYPE_FAILURE] (state) {
    state.sae_type = null
  }
}

// actions
export const actions = {
  async fetchSaeTypes ({ commit }) {
    try {
      const uri = '/api/sae_types'
      const { data } = await axios.get(uri)
      commit(types.SET_SAE_TYPES, data)
    } catch (e) {
      console.log(e)
    }
  },
  async fetchSaeType ({ commit }, sae_type) {
    try {
      const uri = '/api/sae_types'
      const { data } = await axios.get(`${uri}/${sae_type.id}`)

      commit(types.SET_SAE_TYPE, { sae_type: data })
    } catch (e) {
      commit(types.FETCH_SAE_TYPE_FAILURE)
    }
  },

  async createSaeType (context, sae_type) {
    try {
      await axios.post('/api/sae_types', sae_type)
      context.dispatch('fetchSaeTypes')
    } catch (e) {
      console.log(e)
    }
  },

  async updateSaeType (context, sae_type) {
    try {
      await axios.put(`/api/sae_types/${sae_type.id}`, sae_type)
      context.dispatch('fetchSaeTypes')
    } catch (e) { }
  },

  async deleteSaeType (context, sae_type) {
    try {
      await axios.delete(`/api/sae_types/${sae_type.id}`)
      context.dispatch('fetchSaeTypes')
    } catch (e) { }
  }
}

// getters
export const getters = {
  sae_types: state => state.sae_types
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/sae-type.js